<script setup lang="ts">
import { useHead } from '@vueuse/head'
import {
  CDashboardOverviewSection,
  CHeroSection,
  CHowToStart,
  CInfoCards,
  CJoinToday,
  CLandingPricingSection,
  CResourcesSection,
  CWhyChooseUs,
} from '@/features/landing'
// CTestimonialsSection removed — commented out in template

useHead({
  title: 'MarketAssist — сервис автоматизации продаж на Wildberries',
  meta: [
    {
      name: 'description',
      content:
        'MarketAssist — сервис для продавцов Wildberries: калькулятор прибыли, авто-биддер ставок, управление отзывами и поставками, репакер и аналитика в одном кабинете.',
    },
    { property: 'og:title', content: 'MarketAssist — сервис автоматизации продаж на Wildberries' },
    { property: 'og:url', content: 'https://marketassist.ru/' },
  ],
  link: [{ rel: 'canonical', href: 'https://marketassist.ru/' }],
})
</script>

<template>
  <div>
    <CHeroSection />
    <div class="bg-[#F4F8FA] pt-8 md:pt-20 flex flex-col gap-4 lg:gap-10">
      <CDashboardOverviewSection />
      <CInfoCards />
      <CWhyChooseUs />
      <CLandingPricingSection />
      <!-- <CTestimonialsSection /> -->
      <div class="bg-white">
        <CHowToStart />
        <CJoinToday />
        <CResourcesSection />
      </div>
    </div>
  </div>
</template>
